import '@src/scss/disclosure.scss'
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.disclosure-table a').forEach(link => {
        link.setAttribute('target', '_blank')
    })
    document.querySelectorAll('.disclosure-table__title').forEach(title => {
        if (!title.textContent.trim()) {
            title.style.borderTop = 'none'
        }
    })
    document.querySelectorAll('.disclosure-table__num').forEach(title => {
        if (!title.textContent.trim()) {
            title.style.borderTop = 'none'
        }
    })
})
